import React from 'react';
import { motion } from 'framer-motion';

const Marquee = ({ children, speed = 50 }) => {
  return (
    <div className="relative overflow-hidden py-8">
      <motion.div
        className="flex whitespace-nowrap"
        animate={{
          x: [0, -1920],
        }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: speed,
            ease: "linear",
          },
        }}
      >
        {[...Array(4)].map((_, i) => (
          <div key={i} className="flex items-center gap-8 px-4">
            {children}
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default Marquee;
